import BackgroundDownloadVue from '@/views/unbindMember/backgroundDownload/backgroundDownload.vue';

const basePath = '/unbind-member/background-download';
const role = 'unbindMember'; // 角色身份

export const UN_M_BACKGROUND_DOWNLOAD_INDEX = 'un-m-background-download-index';

export default {
    path: `${basePath}*`,
    redirect: `${basePath}/index`,
    component: BackgroundDownloadVue,
    meta: { requiresAuth: true },
    children: [{
        path: `${basePath}/index`,
        name: UN_M_BACKGROUND_DOWNLOAD_INDEX,
        component: () =>
            import (
                /* webpackChunkName: "background-download" */
                `@/views/${role}/backgroundDownload/index.vue`
            ).catch(() =>
                import ('@/views/errors/404.vue')),
        meta: { requiresAuth: true }
    }, ]
};